import { Directive, HostListener } from "@angular/core"

@Directive({
  selector: "input[type=number]",
  standalone: true,
})
export class NoScrollInputDirective {
  @HostListener("wheel", ["$event"])
  onWheel(event: WheelEvent): void {
    const input = event.target as HTMLInputElement
    input.blur()
    event.preventDefault()
    event.stopPropagation()
  }

  @HostListener("focus", ["$event"])
  onFocus(event: FocusEvent): void {
    const input = event.target as HTMLInputElement
    input.addEventListener(
      "wheel",
      (e) => {
        e.preventDefault()
      },
      { passive: false },
    )
  }
}
